export const setElementStyle = (element: HTMLElement, css: Partial<CSSStyleDeclaration>) =>
  Object.assign(element.style, css)
